export default class VideoExport {
  constructor(parentGlobeController) {
    console.log("INIT video export");
    this.parentGC = parentGlobeController;
    this.parentGlobe = parentGlobeController.globe;
    this.isRendering = false;
    this.isInit = false;
  }

  initVideo() {
    var thisVideoExport = this;
    this.oldSetTimeout = window.setTimeout;
    this.oldClearTimeout = window.clearTimeout;
    this.oldClearInterval = window.clearInterval;
    this.oldSetInterval = window.setInterval;
    this.oldRequestAnimationFrame = window.requestAnimationFrame;

    this.isInit = true;
    clearInterval(this.parentGlobe.drawFlowInterval);
    this.capturer = new CCapture( {
      framerate: this.parentGlobe.config.flow.fps,
      format: this.parentGlobe.config.export.format,
      quality: this.parentGlobe.config.export.quality,
      workersPath: earthcorevisu.libPath + "/libs/gif/",
      //verbose: true
    } );

    this.capturer.on('process',function(e){console.log("PROCESS",e);});
    this.capturer.on('finished',function(e){console.log("FINISHED",e);});
    this.capturer.on('progress',function(e){console.log("PROGRESS",e);});
    this.capturer.on('error',function(e){console.log("ERROR",e);});

    this.cancelRendering = false;
    this.parentGC.parentDiv.find(".progressloader").show();
    this.parentGC.parentDiv.find(".progressloader .loader").html("<b>Init video export</b><br>...");

    this.parentGC.parentDiv.find(".exportvideobtn").addClass("disabled");
    this.parentGC.parentDiv.find(".cancelexportvideobtn")
          .removeClass("disabled")
          .off()
          .click(function(){
            thisVideoExport.cancelRendering = true;
          });
    this.parentGC.parentDiv.find(".downloadvideobtn").addClass("disabled");

    window.URL.revokeObjectURL(this.videourl); // delete old blob if exists
    this.capturer.start();

    window.setTimeout = this.oldSetTimeout;
    window.clearTimeout = this.oldClearTimeout;
    window.clearInterval = this.oldClearInterval;
    window.setInterval = this.oldSetInterval;
    window.requestAnimationFrame = this.oldRequestAnimationFrame;
  }

  reset() {
    console.log("Canceling");
    this.isRendering = false;
    this.capturer.stop();
    this.isInit = false;
    if (this.parentGlobe.config.flow.show) {
      this.parentGlobe.animateFlow();
    }
    this.parentGC.parentDiv.find(".exportvideobtn").removeClass("disabled");
    this.parentGC.parentDiv.find(".cancelexportvideobtn").addClass("disabled");
    this.parentGC.parentDiv.find(".progressloader").hide();
    this.resolve();
  }

  buildFrames(save){
    console.log("BUILDING FRAME",this.currentFrame)
    console.log(this);
    var thisVideoExport = this;
    if (this.cancelRendering) {
      this.reset();
      return;
    }

    if (this.parentGlobe.config.export.duration>0) {
      this.parentGC.parentDiv.find(".progressloader .loader").html(
        "<b>Exporting current snapshot</b><br>"+
        (this.currentFrame/this.parentGlobe.config.flow.fps * 1000).toFixed(0) + "ms" +
        " ("+ (this.currentFrame/(this.parentGlobe.config.export.duration*this.parentGlobe.config.flow.fps)*100).toFixed(0)+
        "%)");
    } else {
      this.parentGC.parentDiv.find(".progressloader .loader").html(
        "<b>Exporting Single Image</b>");
    }

    this.currentFrame += 1;

    if (this.parentGlobe.config.flow.data && this.parentGlobe.config.flow.show) {
      this.parentGlobe.particles.evolve();
      this.parentGlobe.particles.draw();
    }
    console.log("    -Envolved")
    var renderctx = this.parentGlobe.renderContext;
    renderctx.fillStyle = "rgba(255,255,255,1)";
    renderctx.fillRect(0,0,this.parentGC.width,this.parentGC.height);

    if (this.parentGlobe.config.export.overlay) {
      renderctx.globalAlpha = $("#"+this.parentGlobe.name+"overlaycanvas").css("opacity");
      renderctx.drawImage(document.getElementById(this.parentGlobe.name+"overlaycanvas"),0,0);
    }
    if (this.parentGlobe.config.export.particles) {
      renderctx.globalAlpha = $("#"+this.parentGlobe.name+"particlescanvas").css("opacity");
      renderctx.drawImage(document.getElementById(this.parentGlobe.name+"particlescanvas"),0,0);
    }
    if (this.parentGlobe.config.export.map) {
      renderctx.globalCompositeOperation = $("#"+this.parentGlobe.name+"mapcanvas").css('mix-blend-mode');
      renderctx.globalAlpha = $("#"+this.parentGlobe.name+"mapcanvas").css("opacity");
      renderctx.drawImage(document.getElementById(this.parentGlobe.name+"mapcanvas"),0,0);
      renderctx.globalCompositeOperation = "source-over";
    }
    if (this.parentGlobe.config.export.legend) {
      renderctx.globalAlpha = $("#"+this.parentGlobe.name+"legendcanvas").css("opacity");
    	renderctx.drawImage(document.getElementById(this.parentGlobe.name+"legendcanvas"),0,0);
    }

    //this.gif.addFrame(document.getElementById(this.parentGlobe.name+"rendercanvas"),
    //  { delay: 1/ this.parentGlobe.config.flow.fps * 1000,
    //    copy:true });
    console.log("    -Plot")

    this.capturer.capture( document.getElementById(this.parentGlobe.name+"rendercanvas") , function(){
      console.log("    - Callback capture")
      if ((thisVideoExport.parentGlobe.config.export.duration==0) &&
        (thisVideoExport.parentGlobe.config.export.format == "jpg" ||
         thisVideoExport.parentGlobe.config.export.format == "png") &&
         !thisVideoExport.addedFrame)
      {
        console.log('BUG FIX')
        thisVideoExport.addedFrame = true;
        requestAnimationFrame(function() {thisVideoExport.buildFrames(save);});
        return;
      }

      if(thisVideoExport.currentFrame< thisVideoExport.parentGlobe.config.export.duration*thisVideoExport.parentGlobe.config.flow.fps){
        console.log("    -Goto Next frame")
    		requestAnimationFrame(function() {thisVideoExport.buildFrames(save);});
    	}
      else
      {
        console.log("    -LAST FRAME");
        thisVideoExport.addedFrame = false;
        if (save) {
          thisVideoExport.capturer.save( function( blob ) {
            console.log("END GENERATING VIDEO");
                    //window.open(URL.createObjectURL(blob));
            var filename = "globe";

            switch(thisVideoExport.parentGlobe.config.export.format) {
            case "webm":
              filename += ".webm";
              break;
            case "gif":
              filename += ".gif";
              break;
            default:
              filename += ".tar";
            }

            thisVideoExport.videourl = URL.createObjectURL(blob);
            thisVideoExport.reset();
            thisVideoExport.parentGC.parentDiv.find(".downloadvideobtn")
                        .removeClass("disabled")
                        .attr("href", thisVideoExport.videourl)
                        .attr("download", filename);
          } );
        }
        thisVideoExport.resolve();
      }
    });

  }

  /**
   * Export current snapshot
   */
  captureSnapshot(save){
    var thisVideoExport = this;
    return new Promise((resolve, reject) => {
      console.log("START CAPTURE")
      thisVideoExport.resolve = resolve;
      thisVideoExport.reject = reject;
      thisVideoExport.addedFrame = false;

      if (!thisVideoExport.isInit) {
        console.log("INIT");
        thisVideoExport.initVideo();
      }

      thisVideoExport.currentFrame = 0;
      thisVideoExport.cancelRendering = false;
      console.log("CURRENT FRAME",0)
      if (thisVideoExport.isRendering) {
        console.log("requestAnimationFrame")
        requestAnimationFrame(function() {thisVideoExport.buildFrames(save);});
      } else {
        console.log("news buildFrames")
        thisVideoExport.isRendering = true;
        thisVideoExport.buildFrames(save);
      }
    });
  }

  /**
   * Export time animation
   */
  captureTimeAnimation(timeSlider) {
    var thisVideoExport = this;
    if (!timeSlider.isExporting) {
      timeSlider.initExport();
    }
    if (this.cancelRendering) {
      timeSlider.cancelExport();
    }

    console.log("exportVideoFrames")
    var save = false;
    if (timeSlider.remainingExport.length == 1) {
      save = true; // last element --> we save video
    }
    if (timeSlider.remainingExport.length == 0) {
      // Export finished
      timeSlider.afterExport();
      return;
    }

    var currentTime = timeSlider.remainingExport.shift();
    timeSlider.setSelected(currentTime)
      .then(function(){
        timeSlider.parentDiv.find(".index" + currentTime).addClass("pulse");
        thisVideoExport.captureSnapshot(save)
          .then(function(){
            console.log(currentTime,'END CAPTURING CURRENT DATE');
            if (thisVideoExport.cancelRendering) {
              timeSlider.cancelExport();
              return;
            }
            timeSlider.parentDiv.find(".index" + currentTime).addClass("done");
            timeSlider.parentDiv.find(".index" + currentTime).removeClass("pulse pending");
            thisVideoExport.captureTimeAnimation(timeSlider);
          });
      });
  }

}



//////////////////
// WEBPACK FOOTER
// ./src/controller/videoExport.js
// module id = 14
// module chunks = 0